import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import "./index.css";

function FormInput(props) {
  const { control, errors } = useFormContext();
  const {
    name,
    required,
    errorobj,
    variant,
    fullWidth = true,
    defaultValue = "",
    InputLabelProps,
  } = props;
  let isError = false;
  let errorMessage = "";
  if (errors && errors.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errors[name].message;
  }

  const textFieldController = (
    <>
      <Controller
        control={control}
        defaultValue={defaultValue}
        {...props}
        render={(uiprops) => (
          <TextField
            {...uiprops}
            {...props}
            variant={variant || "outlined"}
            error={isError}
            fullWidth={fullWidth}
            helperText={errorMessage}
            InputLabelProps={{
              className: required ? "required-label" : "",
              required: required || false,
              ...InputLabelProps,
            }}
          />
        )}
      />
    </>
  );

  return textFieldController;
}

export default FormInput;
